import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { push } from 'connected-react-router'
import { Mode } from '@ocean/types/dist/appearance'
import GoToButton from '../GoToButton'

export type ActivityBackButtonProps = {
  mode?: Mode
  dataTest?: string
}

const ActivityBackButton: React.FC<ActivityBackButtonProps> = props => {
  const { mode, dataTest } = props
  const { t } = useTranslation()
  const search = useLocation().search
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(search)
  const isBackToProgramPlayer = searchParams.get('programId') ? true : false
  const onBackToProgramPlayerClick = () => {
    dispatch(push(`/program/details/${searchParams.get('programId') ?? ''}`))
  }
  return (
    <>
      {isBackToProgramPlayer ? (
        <GoToButton
          mode={Mode.Dark}
          dataTest={dataTest}
          title={t(`activity.backToProgram`)}
          onClick={onBackToProgramPlayerClick}
        />
      ) : (
        <GoToButton mode={mode ?? Mode.Dark} dataTest={dataTest} />
      )}
    </>
  )
}

export default ActivityBackButton
